import { useRouter } from 'expo-router';
import { Image, StyleSheet, View } from 'react-native';

import { t } from 'state/intl/translations';

import { LoyaltyPartnerTile } from '../loyalty-partner-tile';

const SPOTIFY_ROUTE = '/spotify';

const spotifyLogo = require('./spotify-premium-logo.png');

export const SpotifyTile = () => {
  const router = useRouter();
  const handlePress = () => {
    router.dismissTo(SPOTIFY_ROUTE);
  };

  return (
    <LoyaltyPartnerTile
      onPress={handlePress}
      image={
        <View style={styles.logoSlot}>
          <Image resizeMode="contain" source={spotifyLogo} style={styles.logoImage} />
        </View>
      }
      title={t('partnershipSpotifyTitle')}
      description={[t('partnershipSpotifyDescription')]}
      ctaLabel={t('learnMore')}
      onCTAPress={handlePress}
    />
  );
};

const styles = StyleSheet.create({
  logoSlot: {
    flex: 1,
    width: '100%',
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoImage: {
    width: 96,
    height: '100%',
  },
});
